import makeStyles from '@mui/styles/makeStyles'
import { ActiveOrdersTile } from './ActiveOrdersTile'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Pages } from '../../router/router'
import { TransparentButton } from './TransparentButton'
import { sortTradeDiaryTable } from '../../redux/actions/filterActions'
import { TraderDiaryByStateOptions } from '../../redux/reducers/filters'
import { TRADER_DIARY_CANCELED, TRADER_DIARY_PARTIAL_SETTLED, TRADER_DIARY_RECEIVED, TRADER_DIARY_SETTLED}  from '../../constants/codeLists'
import Box from '@mui/material/Box'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from '../../redux/hooks/useSelector'

const useStyles = makeStyles(theme => ({
  orderButton: {
    color: theme.palette.error.main,
  },
  orderButtonPartial: {
    color: theme.palette.warning.main,
  },
  newOrder: {
    color: theme.palette.primary.main,
  },
  addMassOrderButton: {
    height: '70px',
    width: '70px',
    color: theme.palette.primary.main,
  },
  tileButton: {
    minWidth: '40%',
    height: '100px',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2.5),
    padding: '0px',
    borderRadius: '11px',
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      minWidth: '100px',
      width: '170px',
    },
  },
  wrapper: {
    overflowX: 'auto',
    display: 'flex',
  },
}))

export const TraderDiaryTiles  = () => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { clientId } = useParams<{ clientId: string }>()
  const { t } = useTranslation()
  const traderDiaries = useSelector(state => state.traderDiaries.traderDiaries)
  const filters = useSelector(state => state.filters)

  const onStateClick = (countState: TraderDiaryByStateOptions) => () => {
    if (clientId === null || clientId === undefined) history.push(Pages.TraderDiary)

    dispatch(sortTradeDiaryTable(countState))
  }

  return (
    <Box className={classes.wrapper}>
      <TransparentButton
        className={classes.tileButton}
        onClick={onStateClick(TraderDiaryByStateOptions.All)}
        content={
          <ActiveOrdersTile
            middleText={traderDiaries && traderDiaries.length > 0 ? traderDiaries.length : '?'}
            bottomText={t('ALL_TRADER_DIARIES')}
            className={classes.orderButton}
            type={filters.sortTraderDiaryBy == 4 ? 'main' : 'basic'}
          />
        }
      />
      <TransparentButton
        className={classes.tileButton}
        onClick={onStateClick(TraderDiaryByStateOptions.Received)}
        content={
          <ActiveOrdersTile
            middleText={
              traderDiaries && traderDiaries.length > 0 ? traderDiaries.filter(item => item.state === TRADER_DIARY_RECEIVED).length : '?'
            }
            bottomText={t('RECEIVED_TRADER_DIARIES')}
            className={classes.orderButton}
            type={filters.sortTraderDiaryBy == 0 ? 'main' : 'basic'}
          />
        }
      />
      <TransparentButton
        className={classes.tileButton}
        onClick={onStateClick(TraderDiaryByStateOptions.Settled)}
        content={
          <ActiveOrdersTile
            middleText={
              traderDiaries && traderDiaries.length > 0 ? traderDiaries.filter(item => item.state === TRADER_DIARY_SETTLED).length : '?'
            }
            bottomText={t('SETTLED_TRADER_DIARIES')}
            className={classes.orderButton}
            type={filters.sortTraderDiaryBy == 1 ? 'main' : 'basic'}
          />
        }
      />
      <TransparentButton
        className={classes.tileButton}
        onClick={onStateClick(TraderDiaryByStateOptions.PartialSettled)}
        content={
          <ActiveOrdersTile
            middleText={
              traderDiaries && traderDiaries.length > 0 ? traderDiaries.filter(item => item.state === TRADER_DIARY_PARTIAL_SETTLED).length : '?'
            }
            bottomText={t('PARTIAL_SETTLED_TRADER_DIARIES')}
            className={classes.orderButton}
            type={filters.sortTraderDiaryBy == 2 ? 'main' : 'basic'}
            longText={true}
          />
        }
      />
      <TransparentButton
        className={classes.tileButton}
        onClick={onStateClick(TraderDiaryByStateOptions.Canceled)}
        content={
          <ActiveOrdersTile
            middleText={
              traderDiaries && traderDiaries.length > 0 ? traderDiaries.filter(item => item.state === TRADER_DIARY_CANCELED).length : '?'
            }
            bottomText={t('CANCELED_TRADER_DIARIES')}
            className={classes.orderButtonPartial}
            type={filters.sortTraderDiaryBy == 3 ? 'main' : 'basic'}
          />
        }
      />
    </Box>
  )
}
